import React from 'react';
import styles from './base.title.module.scss';
import classNames from "classnames";

import {BaseSideTitleBookmaker} from "./base.side-title.bookmaker";

export const BaseSideTitle = ({controller, bookmaker, ElementComponent, source, sportTypeId}) => {
  const bookmakerProps = {
    controller,
    bookmaker,
    source,
    sportTypeId
  }

  return (
    <>
      <BaseSideTitleBookmaker {...bookmakerProps}/>
      {
        ElementComponent ? <div className={classNames(styles.element)}>{ElementComponent}</div> : null
      }
    </>
  )
};

